import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { ControlContainer, FormControl, FormGroup } from '@angular/forms';
import { SharedModule } from '@apps/portal/src/app/shared/shared.module';
import { HlmCheckboxComponent } from '@spartan-ng/ui-checkbox-helm';
import { HlmLabelDirective } from '@spartan-ng/ui-label-helm';

@Component({
  selector: 'app-checkbox',
  standalone: true,
  imports: [SharedModule, HlmCheckboxComponent, HlmLabelDirective],
  templateUrl: './checkbox.component.html',
  viewProviders: [
    {
      provide: ControlContainer,
      useFactory: () => inject(ControlContainer, { skipSelf: true }),
    },
  ],
})
export class CheckboxComponent implements OnInit {
  @Output() onLabelChange: EventEmitter<Event> = new EventEmitter<Event>();

  @Input({ required: true }) control = '';
  @Input() disabled = false;
  @Input() name = '';
  @Input() label = '';
  @Input() labelClick = false;

  errorMessages: Record<string, string>;

  parentContainer = inject(ControlContainer);

  get parentFormGroup() {
    return this.parentContainer.control as FormGroup;
  }

  ngOnInit(): void {
    this.parentFormGroup.addControl(this.control, new FormControl(null));
    this.setErrorMessages();
  }

  onLabelClick(event: Event) {
    this.onLabelChange.emit(event);
  }

  private setErrorMessages() {
    this.errorMessages = {
      required: 'This field is required',
    };
  }

  displayErrors() {
    const { invalid, dirty, touched } = this.parentFormGroup.get(this.control) as FormControl;
    return invalid && (dirty || touched);
  }

  get formControl() {
    return this.parentFormGroup.get(this.control) as FormControl;
  }
}
